import { useEffect, useState, useMemo, useRef } from "react";
import { useNavigate, NavLink } from "react-router-dom";
import "./Matches.css";
import star from "../../competitionImage/star.png";
import backArrow from "../../../../images/arrow.png";
import whiteArrow from "../../../../images/white-arrow.png";
import Skeleton from "../../../../components/Skeleton";
import { Helmet } from "react-helmet-async";

const Matches = ({
  dark,
  matches = [],
  loading = false,
  error,
  competition,
}) => {
  const [filteredMatches, setFilteredMatches] = useState([]);
  const [selectedDate, setSelectedDate] = useState("");
  const [selectedRound, setSelectedRound] = useState("");

  const navigate = useNavigate();

  const matchesRef = useRef(null);

  const createSlug = (leagueName) => {
    return leagueName
      ?.toLowerCase()
      .trim()
      .replace(/\s+/g, "-")
      .replace(/[^a-z0-9-]/g, "");
  };

  const createSlugName = (home, away) => {
    return `${home}-vs-${away}`
      .toLowerCase()
      .replace(/\s+/g, "-")
      .replace(/[^\w-]+/g, "");
  };

  const leagueInfo = competition?.league || {};
  const leagueId = leagueInfo?.id;
  const slug = createSlug(leagueInfo?.name);

  const country =
    competition?.country?.name || competition?.country || "Unknown Country";

  const currentSeason = competition?.season?.year || competition?.season || "";

  useEffect(() => {
    let filtered = [...matches];

    if (selectedRound) {
      filtered = filtered.filter(
        (match) => match?.league?.round === selectedRound,
      );
    }

    if (selectedDate) {
      filtered = filtered.filter((match) => {
        const matchDate = match?.fixture?.date?.split("T")[0];

        return matchDate === selectedDate;
      });
    }

    setFilteredMatches(filtered);
  }, [selectedRound, selectedDate, matches]);

  const rounds = useMemo(() => {
    const uniqueRounds = new Set();

    matches.forEach((match) => {
      if (match?.league?.round) {
        uniqueRounds.add(match.league.round);
      }
    });

    return [...uniqueRounds];
  }, [matches]);

  const [viewState, setViewState] = useState({});

  const toggleView = (key) => {
    setViewState((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const groupedMatches = useMemo(() => {
    const grouped = {};

    filteredMatches.forEach((match) => {
      const rawDate = match?.fixture?.date;

      if (!rawDate) return;

      const dateObj = new Date(rawDate);

      const formattedDate = dateObj.toLocaleDateString("en-GB", {
        weekday: "long",
        day: "2-digit",
        month: "short",
        year: "numeric",
      });

      if (!grouped[formattedDate]) {
        grouped[formattedDate] = [];
      }

      grouped[formattedDate].push(match);
    });

    return grouped;
  }, [filteredMatches]);

  const [myFav, setMyFav] = useState({});

  const favorite = (matchId) => {
    setMyFav((prev) => ({
      ...prev,
      [matchId]: !prev[matchId],
    }));
  };

  useEffect(() => {
    if (matchesRef.current) {
      matchesRef.current.scrollIntoView({
        behavior: "auto",
        inline: "center",
        block: "nearest",
      });
    }
  }, []);

  const [isStickyTop, setIsStickyTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.innerWidth <= 600) {
        if (window.scrollY >= 98) {
          setIsStickyTop(true);
        } else {
          setIsStickyTop(false);
        }
      } else {
        if (window.scrollY >= 300) {
          setIsStickyTop(true);
        } else {
          setIsStickyTop(false);
        }
      }
    };

    window.addEventListener("scroll", handleScroll);

    handleScroll();

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="homer">
      <Helmet>
        <title>
          {leagueInfo?.name || "Competition"} Matches | Fixtures & Results
        </title>

        <meta
          name="description"
          content={`Follow live fixtures, match results, and upcoming games for ${leagueInfo?.name}. View full match schedule, scores, and performance updates for the ${currentSeason} season in ${country} football.`}
        />

        <meta
          name="keywords"
          content={`${leagueInfo?.name} matches, fixtures, results, football schedule, ${country} football, ${currentSeason} season matches, live scores, match results, soccer fixtures`}
        />

        <meta property="og:title" content={`${leagueInfo?.name} Matches`} />

        <meta
          property="og:description"
          content={`Check fixtures and results for ${leagueInfo?.name}. Stay updated with match schedules, scores, and live results for the ${currentSeason} season.`}
        />
      </Helmet>

      <div className="matchesWrapper">
        {/* <NavLink
          to="/competition"
          style={{ textDecoration: "none" }}
          className="ppp">
          <strong
            style={{
              cursor: "pointer",
              backgroundColor: "transparent",
              border: dark ? "none" : "none",
              color: dark ? "white" : "black",
              padding: "5px 10px",
              borderRadius: "5px",
            }}>
            {dark ? (
              <img src={whiteArrow} alt="" className="whitearrow" />
            ) : (
              <img src={backArrow} alt="" className="blackarrow" />
            )}
          </strong>
        </NavLink>

        <section
          className="section1"
          style={
            dark
              ? { backgroundColor: "#272727ff" }
              : { backgroundColor: "whitesmoke" }
          }>
          <div>
            <img
              src={
                leagueInfo?.id === 1
                  ? worldCup
                  : league?.logo || leagueInfo?.logo
              }
              alt={league?.name || leagueInfo?.name}
              style={{ backgroundColor: "white" }}
            />

            <h1 style={dark ? { color: "#fafafaff" } : { color: "#161819" }}>
              {league?.name || leagueInfo?.name}
            </h1>
          </div>

          <span>
            <strong
              style={dark ? { color: "#cececeff" } : { color: "#8F8C8C" }}>
              {country} Football
            </strong>

            <strong
              style={dark ? { color: "#cececeff" } : { color: "#8F8C8C" }}>
              Season {currentSeason}
            </strong>
          </span>

          <nav>
            <ul
              style={
                dark
                  ? {
                      backgroundColor: "#333333ff",
                      color: "#fff",
                      width: isStickyTop ? "108%" : "100%",
                      marginLeft: isStickyTop ? "0%" : "0",
                      transform: isStickyTop
                        ? "translateX(-4%)"
                        : "translateX(0)",
                      borderRadius: isStickyTop ? "0px" : "",
                      borderRadius: isStickyTop ? "0px" : "",
                      transition: "all 0.3s",
                    }
                  : {
                      width: isStickyTop ? "108%" : "100%",
                      marginLeft: isStickyTop ? "-4%" : "0",
                      borderRadius: isStickyTop ? "0px" : "",
                      transition: "all 0.3s",
                    }
              }>
              <NavLink
                to={`/competition/${slug}/${leagueId}`}
                end
                className={({ isActive }) => (isActive ? "active" : "navlink")}>
                <li
                  style={dark ? { color: "#d1d1d1ff" } : { color: "#8F8C8C" }}>
                  Overview
                </li>
              </NavLink>

              <NavLink
                to={`/competition/${slug}/${leagueId}/news`}
                className={({ isActive }) => (isActive ? "active" : "navlink")}>
                <li
                  style={dark ? { color: "#d1d1d1ff" } : { color: "#8F8C8C" }}>
                  News
                </li>
              </NavLink>

              <NavLink
                to={`/competition/${slug}/${leagueId}/standings`}
                className={({ isActive }) => (isActive ? "active" : "navlink")}>
                <li
                  style={dark ? { color: "#d1d1d1ff" } : { color: "#8F8C8C" }}>
                  Tables
                </li>
              </NavLink>

              <NavLink
                to={`/competition/${slug}/${leagueId}/matches`}
                className={({ isActive }) => (isActive ? "active" : "navlink")}>
                <li ref={matchesRef}>Matches</li>
              </NavLink>

              <NavLink
                to={`/competition/${slug}/${leagueId}/players`}
                className={({ isActive }) => (isActive ? "active" : "navlink")}>
                <li
                  style={dark ? { color: "#d1d1d1ff" } : { color: "#8F8C8C" }}>
                  Top Players
                </li>
              </NavLink>
            </ul>
          </nav>
        </section> */}

        {!loading && matches.length > 0 ? (
          <div
            style={{ display: "flex", alignItems: "center", gap: "10px" }}
            className="myselect">
            <select
              value={selectedRound}
              onChange={(e) => setSelectedRound(e.target.value)}
              style={dark ? { color: "#dbdbdbff" } : { color: "#161819" }}>
              <option
                value=""
                style={dark ? { color: "#dbdbdbff" } : { color: "#161819" }}>
                All Rounds
              </option>

              {rounds.map((round, index) => (
                <option key={index} value={round}>
                  {round}
                </option>
              ))}
            </select>

            {!dark ? (
              <img
                style={{ scale: "1.2", transform: "rotate(-90deg)" }}
                src={backArrow}
                alt=""
                width="22px"
              />
            ) : (
              <img
                style={{ scale: "0.6", transform: "rotate(90deg)" }}
                src={whiteArrow}
                alt=""
                width="22px"
              />
            )}

            {/* <input 
          type="date" 
          value={selectedDate} 
          onChange={(e)=>setSelectedDate(e.target.value)} 
          style={dark ? { color: "#dbdbdbff" } : { color: "#161819" }}
          className={dark ? "darkInput" : ""}
        /> */}
          </div>
        ) : null}

        {/* {!loading && (<nav><span></span> LIVE</nav>)} */}

        <section
          style={{ flexDirection: "column", padding: "0px" }}
          className="sec"
          id="sec">
          {loading && <Skeleton dark={dark} count={6} />}
          {!loading && matches.length === 0 && (
            <p
              style={{
                textAlign: "center",
                padding: "30px",
                color: dark ? "#d4d4d4" : "#666",
              }}>
              No matches available
            </p>
          )}

          {error && <p style={{ color: "red" }}>{error}</p>}

          {!loading &&
            !error &&
            Object.keys(groupedMatches).map((date, index) => {
              const firstMatch = groupedMatches[date][0];
              const leagueName = firstMatch?.league?.name;
              const leagueRound = firstMatch?.league?.round;
              const leagueSeason = firstMatch?.league?.season;

              return (
                <div key={index} className="dateMatch">
                  <h2
                    style={{
                      marginTop: "30px",
                      padding: "10px",
                      borderRadius: "8px",
                      backgroundColor: dark ? "#1a1a1a" : "#eaeaea",
                      color: dark ? "#acacacff" : "#8F8C8C",
                    }}>
                    <p
                      style={
                        dark ? { color: "#dbdbdbff" } : { color: "#161819" }
                      }>
                      {leagueName} • {leagueRound}{" "}
                    </p>
                    {date} • • Season {leagueSeason}
                  </h2>

                  {groupedMatches[date].map((match, idx) => {
                    const homeTeam = match?.teams?.home;
                    const awayTeam = match?.teams?.away;
                    const goals = match?.goals;
                    const matchId = match?.fixture?.id;

                    return (
                      <div
                        key={matchId || idx}
                        className="matchtable"
                        style={
                          dark
                            ? {
                                backgroundColor: "#333333ff",
                                boxShadow: "none",
                              }
                            : {}
                        }>
                        <span
                          className={
                            match?.fixture?.status?.elapsed > 0 &&
                            match?.fixture?.status?.elapsed < 90 &&
                            match?.fixture?.status?.short !== "FT"
                              ? "live-time"
                              : ""
                          }
                          style={
                            match?.fixture?.status?.elapsed > 0 &&
                            match?.fixture?.status?.elapsed < 90 &&
                            match?.fixture?.status?.short !== "FT"
                              ? {}
                              : dark
                                ? { color: "#dfdfdfff" }
                                : { color: "#3e3f3f" }
                          }>
                          {match?.score?.penalty?.home !== null ||
                          match?.score?.penalty?.away !== null
                            ? "PK"
                            : match?.score?.extratime?.home !== null ||
                                match?.score?.extratime?.away !== null
                              ? "Extra"
                              : match?.fixture?.status?.short === "FT" ||
                                  match?.fixture?.status?.elapsed >= 90
                                ? "FT"
                                : match?.fixture?.status?.elapsed
                                  ? `${
                                      match.fixture.status.elapsed >= 90 &&
                                      match.fixture.status.extra
                                        ? `${match.fixture.status.elapsed}<sup>+${match.fixture.status.extra}</sup>`
                                        : match.fixture.status.elapsed
                                    }'`
                                  : match?.fixture?.status?.short === "NS"
                                    ? new Date(
                                        match?.fixture?.date,
                                      ).toLocaleTimeString([], {
                                        hour: "2-digit",
                                        minute: "2-digit",
                                        hour12: false,
                                      })
                                    : match?.fixture?.status?.short}
                        </span>

                        <NavLink
                          key={match.fixture.id}
                          to={`/matches/${createSlugName(
                            match.teams.home.name,
                            match.teams.away.name,
                          )}/${match.fixture.id}`}
                          state={{ matchId }}
                          style={{ width: "100%" }}>
                          <spam
                            className="matchspam"
                            style={{ backgroundColor: "transparent" }}>
                            <nav style={{ backgroundColor: "transparent" }}>
                              <wrap className="MM">
                                <img
                                  src={homeTeam?.logo}
                                  width="25"
                                  alt={homeTeam?.name}
                                />
                                <p
                                  style={
                                    dark
                                      ? { color: "#dbdbdbff" }
                                      : { color: "#161819" }
                                  }>
                                  {homeTeam?.name}
                                </p>
                              </wrap>

                              {match?.fixture?.status?.short !== "NS" &&
                                match?.fixture?.status?.short !== "CANC" && (
                                  <wrap className="NN">
                                    <strong
                                      style={
                                        dark
                                          ? { color: "#dbdbdbff" }
                                          : { color: "#161819" }
                                      }>
                                      {goals?.home}
                                    </strong>
                                  </wrap>
                                )}
                            </nav>

                            <nav style={{ backgroundColor: "transparent" }}>
                              <wrap className="MM">
                                <img
                                  src={awayTeam?.logo}
                                  width="25"
                                  alt={awayTeam?.name}
                                />
                                <p
                                  style={
                                    dark
                                      ? { color: "#dbdbdbff" }
                                      : { color: "#161819" }
                                  }>
                                  {awayTeam?.name}
                                </p>
                              </wrap>

                              {match?.fixture?.status?.short !== "NS" &&
                                match?.fixture?.status?.short !== "CANC" && (
                                  <wrap className="NN">
                                    <strong
                                      style={
                                        dark
                                          ? { color: "#dbdbdbff" }
                                          : { color: "#161819" }
                                      }>
                                      {goals?.away}
                                    </strong>
                                  </wrap>
                                )}
                            </nav>
                          </spam>
                        </NavLink>

                        <img
                          src={star}
                          alt=""
                          className={myFav[matchId] ? "star" : "nostar"}
                          onClick={() => favorite(matchId)}
                        />
                      </div>
                    );
                  })}
                </div>
              );
            })}
        </section>
      </div>
    </div>
  );
};

export default Matches;
